module.exports = __webpack_public_path__ + "../resources/img/ic_re_consuming_p2.c218fb06.svg";